import React from "react";
import ErrorPage from "../../../components/shared/ErrorPage";

const SearchNoResult = () => (
  <ErrorPage
    imageUrl="/assets/svg/noResultsFound.svg"
    errorPageHeading="No results found"
    errorPageDescription="We couldn’t find any matches. Try adjusting your search."
    class="search headWhite"
  />
);

export default SearchNoResult;
